import { Component, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, ResponseMessageTypes, sidebarDataSelector$, UserService } from '@app/shared';
import { CrudService, RxjsService, SessionService, SnackbarService } from '@app/shared/services';
import { AgentLoginService } from '@app/shared/services/agent-login.service';
import { SignalrConnectionService } from '@app/shared/services/signalr-connection.service';
import { AgentMediaTypes, AuthenticationModuleApiSuffixModels, SharedModuleApiSuffixModels, convertStringsToQueryParams, debounceTimeForSearchkeyword, prepareGetRequestHttpParams, prepareRequiredHttpParams, regionId } from '@app/shared/utils';
import { MediaTypes } from '@modules/my-tasks/components/email-dashboard/media-type.enums';
import { LoginUpdate, loggedInUserData } from '@modules/others';
import { SalesModuleApiSuffixModels } from '@modules/sales/shared';
import { UserModuleApiSuffixModels } from '@modules/user/shared';
import { Store } from '@ngrx/store';
import { TelephonyApiSuffixModules } from '@sales/shared';
import { DialogService } from 'primeng/api';
import { Observable, combineLatest, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { ExtensionModalComponent } from './extension-modal.component';
import { AgentLoginDataLoaded, AgentLogoutDataRemoved, agentEncryptedPassword$, agentKey$, agentLoginDataSelector, agentLoginMediaTypesSelector, agentStatus } from './state';
declare var $: any;

export enum RoutingStates {
  AVAILABLE = 1,
  UNAVAILABLE = 2,
  WORK = 3,
  LOGGEDOFF = 4,
  UNKNOWN = 0
}
@Component({
  selector: '[app-header]',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
})
export class AppHeader {
  search: FormControl = new FormControl();
  customersList;
  UserStatusList = [];
  isRequestInProgress = true;
  noRecordsFound = false;
  loggedInUserData: LoggedInUserModel = new LoggedInUserModel();
  selectedUserStatusCssClass;
  userStatusId;
  agentExtensionNo = "";
  newState: any;
  notifications = [];
  notificationsCount = 0;
  isShowSubMenu = false;
  isShowAgentMenu = false;
  mediaList = [
    {
      mediaName: 'Voice',
      status: false,
      statusColor: 'status-label-pink',
      tickColor: '',
      mediaId: 1
    },
    {
      mediaName: 'Email',
      status: false,
      statusColor: 'status-label-pink',
      tickColor: '',
      mediaId: 3
    },
    {
      mediaName: 'Callback',
      status: false,
      statusColor: 'status-label-pink',
      tickColor: '',
      mediaId: 2,
    }
  ];
  items = [];
  screenHeight: number;
  screenWidth: number;
  setIntervalToCheckUserStatus: NodeJS.Timer;
  agentLoginMediaTypes: string[];
  agentStatus: RoutingStates;
  agentKey = "";
  agentEncryptedPassword = "";

  constructor(private crudService: CrudService, private route: ActivatedRoute, private sessionService: SessionService,
    private router: Router, private store: Store<AppState>, private rxjsService: RxjsService,
    public dialogService: DialogService, private snackbarService: SnackbarService,
    private userService: UserService, private signalrConnectionService: SignalrConnectionService,
    private agentLoginService: AgentLoginService
  ) {
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData), 
      this.store.select(agentLoginDataSelector),
      this.store.select(agentLoginMediaTypesSelector), 
      this.store.select(agentStatus),
      this.store.select(sidebarDataSelector$)
  ])
      .subscribe((response) => {
        this.loggedInUserData = new LoggedInUserModel(response[0]);
        this.agentExtensionNo = response[1];
      
      

        // Retrieve agent logged in media types from ngrx store
        if (response[2]) {
          this.agentLoginMediaTypes = response[2];
          if (this.agentLoginMediaTypes?.length > 0) {
            if (this.setIntervalToCheckUserStatus) {
              clearInterval(this.setIntervalToCheckUserStatus);
            }
            this.frequentServerCallToCheckUserAvailableStatus();
          }
          else if (this.agentStatus !== RoutingStates.AVAILABLE && this.setIntervalToCheckUserStatus) {
            clearInterval(this.setIntervalToCheckUserStatus);
          }
        }
        // Retrieve agent logged in media types from ngrx store
        if (response[3]) {
          this.agentStatus = response[3];
          if (this.agentStatus) {
            if (this.setIntervalToCheckUserStatus) {
              clearInterval(this.setIntervalToCheckUserStatus);
            }
            this.frequentServerCallToCheckUserAvailableStatus();
          }
          else if (this.agentLoginMediaTypes?.length == 0 && this.setIntervalToCheckUserStatus) {
            clearInterval(this.setIntervalToCheckUserStatus);
          }
        }
        if (response[4]) {
          this.isShowAgentMenu = this.agentLoginService.isOpenScapeProvider;
        }
      });
  }

  combineLatestNotificationObservables() {
    this.rxjsService.getNotifications().subscribe((response) => {
      if (response) {
        this.notifications = response.notifications ? response.notifications : [];
        this.notificationsCount = response.count ? response.count : 0;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  ngOnInit(): void {
    this.gotoTop();
    this.getScreenSize();
    this.combineLatestNotificationObservables();
    this.combineLatestNgrxStoreData();
    this.combineLatestAgentData();
    this.getUserStatusList();
    this.setupAgentDataBroadcastListener();
    this.search.valueChanges
      .pipe(
        debounceTime(debounceTimeForSearchkeyword),
        distinctUntilChanged(),
        switchMap(search => {
          this.customersList = [];
          this.noRecordsFound = false;
          if (!search || search.trim().length < 3) {
            this.isRequestInProgress = false;
            this.rxjsService.setGlobalLoaderProperty(false);
            return of();
          }
          this.isRequestInProgress = true;
          return this.getCustomersListByKeyword(search.trim());
        }),
        tap(() => {
          this.rxjsService.setGlobalLoaderProperty(false);
        })).subscribe((response: IApplicationResponse) => {
          if (response.isSuccess && response.statusCode === 200) {
            this.customersList = response.resources;
          }
          else {
            this.customersList = [];
          }
          this.noRecordsFound = !this.customersList || this.customersList.length == 0;
          this.isRequestInProgress = false;
        });
    if (this.agentExtensionNo) {
      this.getActiveExtension();
    }
  }

  frequentServerCallToCheckUserAvailableStatus() {
    // 30 seconds Interval based server call to make sure that user is in available state in order to get inbound queue calls any time
    if (this.agentExtensionNo && this.selectdStatus.toLowerCase() == 'available' &&
      (this.agentLoginMediaTypes?.includes(AgentMediaTypes.VOICE) || this.agentLoginMediaTypes?.includes(AgentMediaTypes.CALLBACK))) {
      let userStatusId = '';
      if (this.agentStatus) {
        userStatusId = this.UserStatusList?.find(us => us.id === this.agentStatus)?.id;
      }
      else {
        userStatusId = this.UserStatusList?.find(us => us.displayName.toLowerCase() === this.selectdStatus.toLowerCase())?.id;
      }
      this.setIntervalToCheckUserStatus = setInterval(() => {
        this.rxjsService.setNotificationProperty(false);
        this.crudService.update(ModulesBasedApiSuffix.AUTHENTICATION, AuthenticationModuleApiSuffixModels.UX_USER_CHANGE_STATUS, {
          userId: this.loggedInUserData.userId,
          userStatusId,
          isDefaultLoaderDisabled: true
        }).subscribe();
      }, 30000);
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  gotoTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getNotificationCount() {
    if (this.loggedInUserData?.userId) {
      this.crudService.get(ModulesBasedApiSuffix.COMMON_API, SharedModuleApiSuffixModels.NOTIFICATIONS, this.loggedInUserData.userId)
        .subscribe((response: IApplicationResponse) => {
          if (response.isSuccess && response.statusCode == 200 && response.resources) {
            this.rxjsService.setNotifications({ notifications: response.resources.notifications, count: response.resources.notificationCount });
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        });
    }
  }

  onNotificationClicked(notification) {
    this.rxjsService.setNotificationProperty(false);
    if (notification.type == 'Technician Stock Order Collection') {
      this.rxjsService.setGlobalLoaderProperty(false);
      return
    }
    if (notification.type != "Technician Stock Order Collection" && !notification.url) {
      this.snackbarService.openSnackbar("Navigation URL is not mapped with this notification", ResponseMessageTypes.WARNING);
      this.rxjsService.setGlobalLoaderProperty(false);
      return
    }
    if (notification.type == 'Business Notification') {
      this.rxjsService.setBusinessNotificationProperty(true);
    } else {
      this.rxjsService.setBusinessNotificationProperty(false);
    }
    this.crudService.update(ModulesBasedApiSuffix.COMMON_API, SharedModuleApiSuffixModels.NOTIFICATIONS, {
      notificationId: notification.notificationId,
      modifiedUserId: this.loggedInUserData.userId,
      notificationTo: notification.notificationTo
    }).subscribe((response: IApplicationResponse) => {
      if (response.statusCode == 200 && response.isSuccess) {
        this.crudService.get(ModulesBasedApiSuffix.COMMON_API, SharedModuleApiSuffixModels.NOTIFICATIONS, this.loggedInUserData.userId)
          .subscribe((response: IApplicationResponse) => {
            if (response.isSuccess && response.statusCode == 200 && response.resources) {
              this.rxjsService.setNotifications({ notifications: response.resources.notifications, count: response.resources.notificationCount });
            }
          });
        this.rxjsService.setGlobalLoaderProperty(false);
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
    switch (true) {
      case notification.url.includes('my-tasks/my-sales/my-unqualified-leads/view'):
        this.rxjsService.setFromUrl('My Notifications');
        break;
      case notification.url.includes('sales/unqualified-lead/view'):
        this.rxjsService.setFromUrl('Notifications');
        break;
      case notification.url.includes('my-tasks/my-sales/my-leads/lead-info/view'):
        this.rxjsService.setFromUrl('My Notifications');
        break;
      case notification.url.includes('sales/task-management/leads/lead-info/view'):
        this.rxjsService.setFromUrl('Notifications');
        break;
    }
    if (notification?.subject == "Call Escalation") {
      window.open(window.location.origin + notification.url);
    } else {
      // this.router.routeReuseStrategy.shouldReuseRoute = () => false;// window title is not chaned issue don't use it
      if (notification.url.indexOf("?") == -1) {
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([notification.url], { relativeTo: this.route });
        // window.location.replace(notification.url.toString());
        this.router.navigate(['/']).then(() => { this.router.navigate([notification?.url]); })
      } else {

        // window.location.replace(notification.url.toString());
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([notification.url.slice(0, notification.url.indexOf("?"))], { relativeTo: this.route, queryParams: convertStringsToQueryParams(notification.url) });
        this.router.navigate(['/']).then(() => { this.router.navigate([notification.url.slice(0, notification.url.indexOf("?"))], { relativeTo: this.route, queryParams: convertStringsToQueryParams(notification.url) }) })

        setTimeout(() => {
          this.rxjsService.setGlobalLoaderProperty(false);
        }, 500);
      }
    }
  }

  displayFn(val) {
    if (val) { return (val?.customerName && val?.customerRefNo) ? val?.customerName + " " + val?.customerRefNo : val; } else { return val }
  }

  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    if (event.option.value) {
      this.removeSession();
      this.router.navigate(['/']).then(() => { this.router.navigate([`/customer/manage-customers/view`], { queryParams: { customerId: event?.option?.value?.customerId, addressId: event?.option?.value?.addressId, navigateTab: 0, monitoringTab: null, } }) })
      this.search.setValue("");
    } else {
      this.snackbarService.openSnackbar("Invalid customer data", ResponseMessageTypes.WARNING);

    }

  }

  removeSession() {
    this.sessionService.removeItem('selectedContractId')
    this.sessionService.removeItem('index')
    this.sessionService.removeItem('agreementTab')
  }

  getUserStatusList() {
    this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_USER_STATUS, this.loggedInUserData.userId).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200 && response.resources) {
        this.UserStatusList = response.resources;
        this.UserStatusList.map(item => {
          if (item.isSelected) {
            this.selectedUserStatusCssClass = item.cssClass;
            this.selectdStatus = item.displayName;
          }
        });
      }
    });
  }

  getCustomersListByKeyword(search: string): Observable<IApplicationResponse> {
    return this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.GLOBAL_SEARCH, undefined,
      false, prepareGetRequestHttpParams(undefined, undefined, { search }));
  }

  selectdStatus = "Select Status";
  selectedParent(parent) {
    this.unSelectStatus();
    parent.keyName = parent.displayName;
    this.selectdStatus = parent.displayName;
    parent.isSelected = true;
    this.onUserStatusChanged(parent);
  }

  selectedChild(parent, child) {
    this.unSelectStatus();
    this.selectdStatus = parent.displayName;
    child.keyName = parent.displayName;
    parent.isSelected = true;
    child.isSelected = true;
    this.onUserStatusChanged(child);
  }

  unSelectStatus() {
    for (const status of this.UserStatusList) {
      status.isSelected = false;
      for (const child of status.subStatus) {
        child.isSelected = false;
      }
    }
  }

  onUserStatusChanged(selectedUserStatusObj): void {
    this.isShowSubMenu = false;
    let selUserStatusObj = this.UserStatusList?.find(u => u.id === selectedUserStatusObj.id);
    this.rxjsService.setNotificationProperty(false);
    this.crudService.update(ModulesBasedApiSuffix.AUTHENTICATION, AuthenticationModuleApiSuffixModels.UX_USER_CHANGE_STATUS, {
      userId: this.loggedInUserData.userId,
      userStatusId: selectedUserStatusObj.id
    }).pipe(tap(() => {
      this.rxjsService.setGlobalLoaderProperty(false);
    })).subscribe((response) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.selectedUserStatusCssClass = selUserStatusObj['cssClass'];
        // After a successful media switching we want to update the media type in the store
        this.store.dispatch(new AgentLoginDataLoaded({
          extensionNo: this.agentExtensionNo ? this.agentExtensionNo : null,
          agentLoginMediaTypes: this.agentLoginMediaTypes,
          agentStatus: selectedUserStatusObj.id,
          agentEncryptedPassword: this.agentEncryptedPassword
        }));
      }
    });
    if (this.agentExtensionNo) {
      if (selectedUserStatusObj.keyName == 'Available') {
        this.newState = RoutingStates.AVAILABLE;
      } else if (selectedUserStatusObj.keyName == 'Unavailable') {
        this.newState = RoutingStates.UNAVAILABLE;
      } else if (selectedUserStatusObj.keyName == "Work") {
        this.newState = RoutingStates.WORK;
      } else {
        this.newState = null;
      }
      if (this.newState) {
        this.checkIfEmailLoggedInAndSetRoutingForEmail({ newStateId: this.newState, reason: selectedUserStatusObj.reasonKey })
        this.crudService.create(ModulesBasedApiSuffix.ROUTING_STATE, AuthenticationModuleApiSuffixModels.SET_ROUTING_STATE_NEW, {
          extension: this.agentExtensionNo,
          newStateId: this.newState,
          pabxId: this.loggedInUserData.openScapePabxId,
          userId: this.loggedInUserData?.userId,
          reason: selectedUserStatusObj.reasonKey
        }).pipe(tap(() => {
          this.rxjsService.setNotificationProperty(true);
          this.rxjsService.setGlobalLoaderProperty(false);
        })).subscribe(() => {
        });
      }
      this.selectedUserStatusCssClass = selUserStatusObj['cssClass'];
    }
  }

  onApplicationLogout() {
    this.userService.onLogout();
  }

  sidebarToggle() {
    $('body').toggleClass('sidebar-mini');
  }

  stopEvent(e) {
    this.isShowSubMenu = !this.isShowSubMenu;
    e.stopPropagation();
  }

  public OpenDialogWindow() {
    this.rxjsService.setDialogOpenProperty(true);
    const dialogReff = this.dialogService.open(ExtensionModalComponent, { width: '450px', showHeader: false });
    this.userService.openedPrimeDialog.push(dialogReff);
    dialogReff.onClose.subscribe(result => {
      if (result) {
        this.agentExtensionNo = result;
        this.combineLatestAgentData('from popup');
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  combineLatestAgentData(type = 'default') {
    combineLatest([this.store.select(agentKey$),
    this.store.select(agentEncryptedPassword$)]).subscribe((response) => {
      this.agentKey = response[0];
      this.agentEncryptedPassword = response[1];
      if (type === 'from popup') {
        this.getActiveExtension();
      }
    });
  }

  checkIfEmailLoggedInAndSetRoutingForEmail(obj) {
    let isEmailLoggedIn = false;
    for (const media of this.mediaList) {
      if (media.mediaId == MediaTypes.EMAIL && media.status == true) {
        isEmailLoggedIn = true;
      }
    }
    if (isEmailLoggedIn) {
      this.crudService.create(ModulesBasedApiSuffix.ROUTING_STATE, AuthenticationModuleApiSuffixModels.SET_ROUTING_STATE_EMAIL, obj).pipe(tap(() => {
        this.rxjsService.setNotificationProperty(true);
        this.rxjsService.setGlobalLoaderProperty(false);
      })).subscribe(() => {
      });
    }
  }

  toggleMedia(media) {
    this.rxjsService.setGlobalLoaderProperty(true);
    let API: TelephonyApiSuffixModules = media.status ? TelephonyApiSuffixModules.AGENT_LOGOFF : TelephonyApiSuffixModules.AGENTLOGIN;
    let payload: any = {
      extension: this.agentExtensionNo,
      userId: this.loggedInUserData?.userId,
      regionId,
      password: this.agentEncryptedPassword
    }
    if (media.status) {
      payload.mediaTypeId = media.mediaId;
    } else {
      payload.mediaTypes = [media.mediaId];
    }
    // TODO:missing use case to handle password at the backend side for seperate media toggle login
    this.crudService.create(ModulesBasedApiSuffix.TELEPHONY, API, payload).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200) {
        // After a successful media switching we want to update the media type in the store
        this.store.dispatch(new AgentLoginDataLoaded({
          extensionNo: this.agentExtensionNo,
          agentLoginMediaTypes: media.mediaId,
          agentStatus: this.agentStatus,
          agentKey: this.agentKey,
          agentEncryptedPassword: this.agentEncryptedPassword
        }));

        // Broadcast media toggle changes to all tabs for synchronization
        const agentDataChannel = new BroadcastChannel('AgentDataSync');
        agentDataChannel.postMessage({
          type: 'AGENT_MEDIA_TOGGLE',
          data: {
            userId: this.loggedInUserData.userId,
            agentKey: this.agentKey,
            extensionNo: this.agentExtensionNo,
            agentLoginMediaTypes: media.mediaId,
            agentStatus: this.agentStatus,
            agentEncryptedPassword: this.agentEncryptedPassword,
            mediaToggle: {
              mediaId: media.mediaId,
              status: !media.status // The new status after toggle
            }
          },
          timestamp: Date.now()
        });
        agentDataChannel.close();

        this.getActiveExtension();
      }
    });
  }

  loggedMedia = [];
  getActiveExtension() {
    if (!this.agentEncryptedPassword || !this.agentKey) {
      return;
    }
    this.crudService.get(ModulesBasedApiSuffix.TELEPHONY, TelephonyApiSuffixModules.LOGGEDIN_MEDIA, null, false, prepareRequiredHttpParams({
      userId: this.loggedInUserData.userId, extension: this.agentExtensionNo
    })).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200 && response.resources) {
        this.loggedMedia = response.resources;
        for (const media of this.loggedMedia) {
          if (media.mediaTypeId == MediaTypes.VOICE) {
            this.mediaList[0].status = !media.isLoggedOff;
            this.mediaList[0].statusColor = this.mediaList[0].status ? 'status-label-green' : 'status-label-red';
            this.mediaList[0].tickColor = this.mediaList[0].status ? 'tick-green' : 'disabled-tick';
          }
          if (media.mediaTypeId == MediaTypes.CALLBACK) {
            this.mediaList[2].status = !media.isLoggedOff;
            this.mediaList[2].statusColor = this.mediaList[2].status ? 'status-label-green' : 'status-label-red';
            this.mediaList[2].tickColor = this.mediaList[2].status ? 'tick-green' : 'disabled-tick';
          }
          if (media.mediaTypeId == MediaTypes.EMAIL) {
            this.mediaList[1].status = !media.isLoggedOff;
            this.mediaList[1].statusColor = this.mediaList[1].status ? 'status-label-green' : 'status-label-red';
            this.mediaList[1].tickColor = this.mediaList[1].status ? 'tick-green' : 'disabled-tick';
          }
        }
        if (this.loggedMedia?.length == 0 || this.mediaList?.filter(mL => !mL['status'])?.length == this.mediaList.length) {
          this.closeAllOpenscapeConfigs();
        }
        if (this.getNonActiveMediaCount() == this.mediaList.length) {
          this.closeAllOpenscapeConfigs();
        }
      }
    });
    this.rxjsService.setGlobalLoaderProperty(false);
  }

  closeAllOpenscapeConfigs() {
    // Close the telephony hub connection if all the media type logins are logged out
    this.signalrConnectionService.closeTelephonyAPIHubConnection();
    // If if all the media type logins are logged out remove the pabxID from ngrx store and update
    this.loggedInUserData.openScapePabxId = null;
    this.loggedInUserData.mediaTypeIds = null;
    this.store.dispatch(new LoginUpdate({
      user: this.loggedInUserData
    }));
    this.store.dispatch(new AgentLogoutDataRemoved());

    // Broadcast agent logout to all tabs for synchronization
    const agentDataChannel = new BroadcastChannel('AgentDataSync');
    agentDataChannel.postMessage({
      type: 'AGENT_LOGOUT',
      data: {
        userId: this.loggedInUserData.userId,
        extensionNo: null,
        openScapePabxId: null,
        mediaTypeIds: null
      },
      timestamp: Date.now()
    });
    agentDataChannel.close();
  }

  getNonActiveMediaCount(): number {
    let count = 0
    for (const iterator of this.mediaList) {
      if (iterator.status === false) {
        count++;
      }
    }
    return count;
  }

  navigateToNotificationList() {
    this.router.navigate(['/notifications']);
  }

  setupAgentDataBroadcastListener() {
    // Listen for agent data synchronization messages from other tabs
    const agentDataChannel = new BroadcastChannel('AgentDataSync');
    agentDataChannel.onmessage = (event) => {
      const { type, data, timestamp } = event.data;

      // Only process messages from other tabs (not our own)
      if (type === 'AGENT_LOGIN_DATA_UPDATED' && data.userId === this.loggedInUserData.userId) {
        // Update agent extension and related data from broadcast
        this.agentExtensionNo = data.extensionNo;

        // Create updated user data object with broadcast data
        const updatedUserData = {
          ...this.loggedInUserData,
          openScapePabxId: data.openScapePabxId,
          mediaTypeIds: data.mediaTypeIds
        };

        // Update ngrx store with received data
        this.store.dispatch(new AgentLoginDataLoaded({
          agentKey: data.agentKey,
          extensionNo: data.extensionNo,
          agentLoginMediaTypes: data.agentLoginMediaTypes,
          agentStatus: data.agentStatus,
          agentEncryptedPassword: data.agentEncryptedPassword
        }));

        this.store.dispatch(new LoginUpdate({
          user: updatedUserData
        }));

        // Refresh active extension status
        if (this.agentExtensionNo) {
          this.getActiveExtension();
        }
      } else if (type === 'AGENT_LOGOUT' && data.userId === this.loggedInUserData.userId) {
        // Handle logout broadcast from other tabs
        this.agentExtensionNo = null;

        // Create updated user data object with cleared data
        const clearedUserData = {
          ...this.loggedInUserData,
          openScapePabxId: null,
          mediaTypeIds: null
        };

        // Update ngrx store to clear agent data
        this.store.dispatch(new LoginUpdate({
          user: clearedUserData
        }));
        this.store.dispatch(new AgentLogoutDataRemoved());

        // Reset media list status
        this.mediaList.forEach(media => {
          media.status = false;
          media.statusColor = 'status-label-pink';
          media.tickColor = '';
        });
      } else if (type === 'AGENT_MEDIA_TOGGLE' && data.userId === this.loggedInUserData.userId) {
        // Handle media toggle broadcast from other tabs
        this.store.dispatch(new AgentLoginDataLoaded({
          agentKey: data.agentKey,
          extensionNo: data.extensionNo,
          agentLoginMediaTypes: data.agentLoginMediaTypes,
          agentStatus: data.agentStatus,
          agentEncryptedPassword: data.agentEncryptedPassword
        }));

        // Refresh active extension status to sync media states
        if (this.agentExtensionNo) {
          this.getActiveExtension();
        }
      }
    };
  }
}
